/**
 * TruBeauté — single source of truth for browser-storage keys.
 *
 * Importing from one file (rather than redeclaring constants in each
 * caller) prevents key-drift bugs where two files reference what they
 * THINK is the same flag but use slightly different strings — silently
 * breaking features like the Stealth Mode analytics kill-switch.
 *
 * See safeStorage.js for the policy on what may be stored.
 */

export const STEALTH_KEY = "trubeaute.stealth.enabled";
export const WAITLIST_DISMISSED_KEY = "trubeaute.waitlist_banner_dismissed";
export const ANALYTICS_SESSION_KEY = "trubeaute.analytics_session_id";
export const PRIVACY_INTRO_SEEN_KEY = "trubeaute.privacy_intro_seen";
export const TTS_ENABLED_KEY = "trubeaute.mirror.tts.enabled";
// Persisted x/y offset (in px) for the AR mirror coach card so users
// only need to drag it once and we remember where they parked it.
// v2 — bumped May 16 2026 because the card layout switched from
// top-right anchored to bottom-center anchored. Old saved offsets
// (computed against the top-right anchor) would land off-screen if
// reused as-is. Bumping the key forces a fresh default for everyone.
export const MIRROR_COACH_POS_KEY = "trubeaute.mirror.coach_card_pos.v2";
// Pending ToS version selected at the /login gate, forwarded to the
// backend by AuthCallback.jsx after the Google OAuth round-trip completes.
// Cleared as soon as it's been recorded server-side.
export const PENDING_TOS_VERSION_KEY = "trubeaute.pending_tos_version";
// Where the user was when they entered Stealth Mode. Set the moment
// stealth flips ON; consumed (and cleared) the moment stealth flips
// OFF so the user lands back on the page they wanted instead of being
// stranded wherever they happened to be when they hit the exit pill.
// Lifesaver for admins who accidentally enable stealth and get
// blocked out of /admin until they realise.
export const STEALTH_ENTRY_URL_KEY = "trubeaute.stealth.entry_url";
